import React, { useEffect, useRef } from "react";
import help_icon from "../images/sidebar_icon/help_icon.svg";
import SelectDropDown from "../components/SelectDropDown";
import calendar_month from "../images/my_profile/calendar_month.svg";
import DatePickerInput from "../components/DatePickerInput";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  pincode,
  userOnboardingGetDetails,
  userOnboardingStoreData,
} from "../actions/usersActions";
import { getLocalStorageUserData } from "../utils/userData";
import { sanitizeInput } from "../utils/sanitizeInput";
import { convertDateToDDMMMYYYY } from "../utils/DateFormate";
// Functional component for the Home page
const PersonalDetails = () => {
  const dateInputRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = getLocalStorageUserData();
  const { userOnboardGetData, userOnboardStoreData, loading, error } =
    useSelector((state) => state.users);

  const handleIconClick = () => {
    if (dateInputRef.current) {
      if (dateInputRef.current.showPicker) {
        dateInputRef.current.showPicker(); // For modern browsers
      } else {
        dateInputRef.current.focus(); // Fallback for older browsers
      }
    }
  };

  console.log("userOnboardGetData", userOnboardGetData);
  useEffect(() => {
    if (userOnboardGetData) {
      if (
        (userOnboardGetData?.wizard_step == 4 ||
          userOnboardGetData?.wizard_step == 5) &&
        userOnboardGetData?.is_wizard_completed == true
      ) {
        window.location.href = "/dashboard";
        // window.location.href = "/dashboard";
      } else if (0 <= parseInt(userOnboardGetData?.wizard_step)) {
      } else {
        if (userOnboardGetData?.wizard_step == 1) {
          window.location.href = "/bank-details";
          // window.location.href = "/bank-details";
        }
        if (userOnboardGetData?.wizard_step == 2) {
          window.location.href = "/fatca-declartion";
          // window.location.href = "/fatca-declartion";
        }
      }
    }
  }, [userOnboardGetData]);

  const handleNextClick = () => {
    window.location.href = "/bank-details"; // "Next" page par navigate karea
  };

  useEffect(() => {
    const payload = {
      completed_wizard_step: "0",
    };
    dispatch(userOnboardingGetDetails(payload));
  }, []);

  const genderOptions = [
    { value: "M", label: "Male" },
    { value: "F", label: "Female" },
    { value: "O", label: "Other" },
  ];

  const maritalOptions = [
    { value: "JO", label: "Joint" },
    { value: "SI", label: "Single" },
    { value: "AS", label: "Anyone Or Survivor" },
  ];

  const sanitizeTest = (fieldName) => ({
    name: `is-sanitized-${fieldName}`,
    test: (value) => {
      const sanitizedValue = sanitizeInput(value);
      return sanitizedValue === value; // Ensure input matches sanitized output
    },
    message: `Input should be sanitized, and no action should occur`,
  });

  console.log("userOnboardGetData", userOnboardGetData?.data?.customer?.primary_holder_middle_name)
  const formik = useFormik({
    initialValues: {
      primary_holder_first_name:
        userOnboardGetData?.data?.customer?.primary_holder_first_name ||
        userOnboardGetData?.data?.user?.name?.split(" ")?.[0],
      primary_holder_middle_name:
        userOnboardGetData?.data?.customer?.primary_holder_middle_name == undefined ? userOnboardGetData?.data?.user?.name?.split(" ")?.[1] : userOnboardGetData?.data?.customer?.primary_holder_middle_name,
      primary_holder_last_name:
        userOnboardGetData?.data?.customer?.primary_holder_last_name ||
        userOnboardGetData?.data?.user?.name?.split(" ")?.[2] ? userOnboardGetData?.data?.user?.name?.split(" ")?.[2] : userOnboardGetData?.data?.user?.name?.split(" ")?.[1],
      primary_holder_dob_incorporation:
        userOnboardGetData?.data?.user?.dob || "",
      email: userOnboardGetData?.data?.user?.email || "",
      // email_relation:
      //   userOnboardGetData?.data?.user?.profile?.email_relation || "",
      // mobile_no: userOnboardGetData?.data?.user?.mobile || "",
      // mobile_relation:
      //   userOnboardGetData?.data?.user?.profile?.mobile_relation || "",
      gender: userOnboardGetData?.data?.customer?.gender || "",
      holding_nature: userOnboardGetData?.data?.customer?.holding_nature || "SI",
      occupation_code:
        userOnboardGetData?.data?.customer?.occupation_code || "",
      primary_holder_pan: userOnboardGetData?.data?.user?.pan || "",
      // adhaar_card: userOnboardGetData?.data?.user?.profile?.adhaar_card || "",
      address_1: userOnboardGetData?.data?.customer?.address_1 || "",
      pincode: userOnboardGetData?.data?.customer?.pincode || "",
      city: userOnboardGetData?.data?.customer?.city || "",
      state: userOnboardGetData?.data?.customer?.state || "",
      country: "INDIA",
      // second_holder_first_name:
      //   userOnboardGetData?.data?.customer?.second_holder_first_name || "",
      // second_holder_middle_name:
      //   userOnboardGetData?.data?.customer?.second_holder_middle_name || "",
      // second_holder_last_name:
      //   userOnboardGetData?.data?.customer?.second_holder_last_name || "",
      // second_holder_dob:
      //   userOnboardGetData?.data?.customer?.second_holder_dob || "",
      // second_holder_pan:
      //   userOnboardGetData?.data?.customer?.second_holder_pan || "",
      // second_holder_email:
      //   userOnboardGetData?.data?.customer?.second_holder_email || "",
      // second_holder_mobile:
      //   userOnboardGetData?.data?.customer?.second_holder_mobile || "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      primary_holder_first_name: Yup.string()
        .transform((value) => value?.trim()) // remove leading/trailing spaces
        .test(sanitizeTest("First Name"))
        .matches(/^[A-Za-z]+$/, "First Name must contain only alphabets")
        .required("First Name is required"),
      // primary_holder_middle_name: Yup.string()
      //   .transform((value) => value?.trim())
      //   .test(sanitizeTest("Parent Name"))
      //   .matches(/^[A-Za-z]+$/, "Parent Name must contain only alphabets")
      //   .required("Parent Name is required"),
      primary_holder_last_name: Yup.string()
        .transform((value) => value?.trim())
        .test(sanitizeTest("Last Name"))
        .matches(/^[A-Za-z]+$/, "Last Name must contain only alphabets")
        .required("Last Name is required"),
      primary_holder_dob_incorporation: Yup.date().required(
        "Date of Birth is required"
      ),
      email: Yup.string()
        .test(sanitizeTest("Email"))
        .email("Enter a valid email address.")
        .required("Email is required"),
      // email_relation: Yup.string()
      //   .notOneOf(["Select"], "Email Belongs To is required")
      //   .required("Email Belongs To is required"),
      // mobile_no: Yup.string()
      //   .test(sanitizeTest("Mobile Number"))
      //   .matches(/^[6-9]\d{9}$/, "Mobile Number must be 10 digits")
      //   .required("Mobile Number is required"),
      // mobile_relation: Yup.string()
      //   .notOneOf(["Select"], "Mobile Belongs To is required")
      //   .required("Mobile Belongs To is required"),
      gender: Yup.string().required("Gender is required"),
      occupation_code: Yup.string()
        .notOneOf(["Select"], "Occupation is required")
        .required("Occupation is required"),
      holding_nature: Yup.string().required("Holding Nature is required"),
      // father_name: Yup.string()
      //   .test(sanitizeTest("Parent Name"))
      //   .matches(/^[A-Za-z\s]+$/, "Parent Name must contain only alphabets")
      //   .required("Parent Name is required"),
      primary_holder_pan: Yup.string()
        .test(sanitizeTest("PAN"))
        .matches(/^[A-Z]{5}[0-9]{4}[A-Z]$/, "Invalid PAN Details")
        .required("PAN is required"),
      // adhaar_card: Yup.string()
      //   .test(sanitizeTest("Aadhar Number"))
      //   .matches(/^\d{12}$/, "Aadhar Number must be 12 digits")
      //   .required("Aadhar Number is required"),
      address_1: Yup.string()
        .test(sanitizeTest("Address"))
        .max(200, "Input should not accept more than 200 characters")
        .required("Address is required"),
      pincode: Yup.string()
        .test(sanitizeTest("Pincode"))
        .matches(/^\d{6}$/, "Pincode must be 6 digits")
        .required("Pincode is required"),
      city: Yup.string()
        .test(sanitizeTest("City"))
        .required("City is required"),
      state: Yup.string()
        .notOneOf(["Select"], "State is required")
        .required("State is required"),
      second_holder_first_name: Yup.string().when("holding_nature", {
        is: (val) => val === "JO" || val === "AS",
        then: (schema) =>
          schema
            .required("Second Holder First Name is required")
            .matches(/^[A-Za-z]+$/, "Must contain only alphabets"),
        otherwise: (schema) => schema.notRequired(),
      }),
      second_holder_middle_name: Yup.string().when("holding_nature", {
        is: (val) => val === "JO" || val === "AS",
        then: (schema) =>
          schema
            .required("Second Holder Middle Name is required")
            .matches(/^[A-Za-z]+$/, "Must contain only alphabets"),
        otherwise: (schema) => schema.notRequired(),
      }),
      second_holder_last_name: Yup.string().when("holding_nature", {
        is: (val) => val === "JO" || val === "AS",
        then: (schema) =>
          schema
            .required("Second Holder Last Name is required")
            .matches(/^[A-Za-z]+$/, "Must contain only alphabets"),
        otherwise: (schema) => schema.notRequired(),
      }),
      second_holder_email: Yup.string().when("holding_nature", {
        is: (val) => val === "JO" || val === "AS",
        then: (schema) =>
          schema
            .test(sanitizeTest("Email"))
            .email("Enter a valid email address."),
        otherwise: (schema) => schema.notRequired(),
      }),
      second_holder_mobile: Yup.string().when("holding_nature", {
        is: (val) => val === "JO" || val === "AS",
        then: (schema) =>
          schema
            .test(sanitizeTest("Mobile Number"))
            .matches(/^[6-9]\d{9}$/, "Mobile Number must be 10 digits"),
        otherwise: (schema) => schema.notRequired(),
      }),
      second_holder_pan: Yup.string().when("holding_nature", {
        is: (val) => val === "JO" || val === "AS",
        then: (schema) =>
          schema
            .required("Second Holder Pan is required")
            .test(sanitizeTest("PAN"))
            .matches(/^[A-Z]{5}[0-9]{4}[A-Z]$/, "Invalid PAN Details")
            .required("PAN is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      second_holder_dob: Yup.date().when("holding_nature", {
        is: (val) => val === "JO" || val === "AS",
        then: (schema) =>
          schema.required("Second Holder Date of Birth is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    onSubmit: (values) => {
      // const formatDate = convertDateToDDMMMYYYY(values?.dob);
      const payload = {
        ...values,
        // dob: formatDate,
        completed_wizard_step: 0,
      };
      dispatch(userOnboardingStoreData(payload)).then((response) => {
        setTimeout(() => {
          if (response.data.success == true) {
            // if (response.data.wizard_step == 1) {
            window.location.href = "/bank-details";
            // } else if (response.data.wizard_step == 2) {
            //   window.location.href = "/fatca-declartion";
            // } else if (response.data.wizard_step == 3) {
            //   window.location.href = "/manage-nominees";
            // } else if (response.data.wizard_step == 4) {
            //   window.location.href = "/dashboard";
            // } else if (response.wizard_step == null) {
            //   window.location.href = "/dashboard";
            // }
          }
        }, 500);
      });
    },
  });

  const callStateAndDistrict = async (pin) => {
    try {
      if (pin?.split("")?.length == 6) {
        const payload = {
          pincode: pin,
        };
        dispatch(pincode(payload))
          .then((res) => {
            formik?.setFieldValue("city", res?.data?.data?.city ? res?.data?.data?.city : "");
            formik?.setFieldValue("state", res?.data?.data?.state_code ? res?.data?.data?.state_code : "");
          })
          .catch((error) => {
            console.log("Error:", error);
          });
      }
    } catch (error) {
      console.error("Error fetching location data:", error);
    }
  };

  if (loading || !userOnboardGetData) {
    return <div>Loading...</div>; // Wait for data before rendering form
  }
  return (
    <div className="container-fluid page_background ">
      <div className="page-inner-content mb-3">
        <div className="progress-container page_inner_content_box">
          <div className="step-info">
            <span>Step 1 of 4</span>
          </div>
          <h4 className="page-title mb-0">Personal Details</h4>
        </div>
        <div className="progress-bar">
          <div className="progress-filled" style={{ width: "25%" }}></div>
        </div>

        <div className="form_group page_inner_content_box d-flex flex-wrap justify-content-between ">
          <form
            id="profile_form"
            onSubmit={formik.handleSubmit}
            className="step_form"
            action=""
          >
            <div className="  card border-0">
              <div className="card-body form_card">
                <div className="row">
                  <div className="col-xl-7 col-lg-8 col-12  order-lg-1 order-2">
                    <div className="row align-items-center mb-4">
                      <div className="col-lg-5 col-md-6">
                        <label
                          htmlFor="primary_holder_first_name"
                          className="form-label"
                        >
                          First Name*
                        </label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          id="primary_holder_first_name"
                          placeholder="Enter Full Name"
                          value={formik.values.primary_holder_first_name}
                          {...formik.getFieldProps("primary_holder_first_name")}
                        />
                        {formik.touched.primary_holder_first_name &&
                        formik.errors.primary_holder_first_name ? (
                          <div className="text-danger">
                            {formik.errors.primary_holder_first_name}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="row align-items-center mb-4">
                      <div className="col-lg-5 col-md-6">
                        <label
                          htmlFor="primary_holder_middle_name"
                          className="form-label"
                        >
                          Father/Husband Name
                        </label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          id="primary_holder_middle_name"
                          placeholder="Enter Full Name"
                          value={formik.values.primary_holder_middle_name}
                          {...formik.getFieldProps(
                            "primary_holder_middle_name"
                          )}
                        />
                        {/* {formik.touched.primary_holder_middle_name &&
                        formik.errors.primary_holder_middle_name ? (
                          <div className="text-danger">
                            {formik.errors.primary_holder_middle_name}
                          </div>
                        ) : null} */}
                      </div>
                    </div>
                    <div className="row align-items-center mb-4">
                      <div className="col-lg-5 col-md-6">
                        <label
                          htmlFor="primary_holder_last_name"
                          className="form-label"
                        >
                          Last Name*
                        </label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          id="primary_holder_last_name"
                          placeholder="Enter Full Name"
                          value={formik.values.primary_holder_last_name}
                          {...formik.getFieldProps("primary_holder_last_name")}
                        />
                        {formik.touched.primary_holder_last_name &&
                        formik.errors.primary_holder_last_name ? (
                          <div className="text-danger">
                            {formik.errors.primary_holder_last_name}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="row align-items-center mb-4">
                      <div className="col-lg-5 col-md-6">
                        <label
                          htmlFor="primary_holder_dob_incorporation"
                          className="form-label"
                        >
                          Date of Birth*
                        </label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <DatePickerInput
                          selectedDate={
                            formik.values.primary_holder_dob_incorporation
                              ? moment(
                                  formik.values
                                    .primary_holder_dob_incorporation,
                                  "YYYY-MM-DD"
                                ).toDate()
                              : null
                          }
                          maxDate={new Date().toISOString().split("T")[0]}
                          onChange={(date) =>
                            formik.setFieldValue(
                              "primary_holder_dob_incorporation",
                              moment(date).format("YYYY-MM-DD") // Save in DB-friendly format
                            )
                          }
                          disable="true"
                        />
                        {/* <DatePickerInput
                          selectedDate={
                            formik.values.primary_holder_dob_incorporation
                          }
                          maxDate={new Date().toISOString().split("T")[0]}
                          onChange={(date) =>
                            formik.setFieldValue(
                              "primary_holder_dob_incorporation",
                              date
                            )
                          }
                        /> */}
                        {formik.touched.primary_holder_dob_incorporation &&
                        formik.errors.primary_holder_dob_incorporation ? (
                          <div className="text-danger">
                            {formik.errors.primary_holder_dob_incorporation}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="row align-items-center mb-lg-4 mb-md-4 mb-4">
                      <div className="col-lg-5 col-md-6">
                        <label htmlFor="email" className="form-label">
                          Email*
                        </label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="anandr@gmail.com"
                  onChange={(e) => formik.setFieldValue("email", e.target.value.toLowerCase())}
                          {...formik.getFieldProps("email")}
                        />
                        {formik.touched.email && formik.errors.email ? (
                          <div className="text-danger">
                            {formik.errors.email}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="row align-items-center mb-lg-4 mb-md-4 mb-4">
                      {/* <div className="col-lg-5 col-md-6">
                        <label htmlFor="email_relation" className="form-label">
                          Email Belongs to*
                        </label>
                      </div> */}
                      {/* <div className="col-lg-7 col-md-6">
                        <SelectDropDown
                          name="email_relation"
                          id=""
                          value={formik.values.email_relation}
                          changeFunction={(value) =>
                            formik?.setFieldValue("email_relation", value)
                          }
                          options={Object.keys(
                            userOnboardGetData?.data?.mobile_email_relations
                          ).map((key) => ({
                            value: key,
                            label:
                              userOnboardGetData?.data?.mobile_email_relations[
                                key
                              ],
                          }))}
                        />
                        {formik.touched.email_relation &&
                        formik.errors.email_relation ? (
                          <div className="text-danger">
                            {formik.errors.email_relation}
                          </div>
                        ) : null}
                      </div> */}
                    </div>
                    {/* <div className="row align-items-center mb-lg-4 mb-md-4 mb-4">
                      <div className="col-lg-5 col-md-6">
                        <label htmlFor="mobile_no" className="form-label">
                          Mobile Number*
                        </label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          id="mobile_no"
                          placeholder="Mobile Number"
                          {...formik.getFieldProps("mobile_no")}
                        />
                        {formik.touched.mobile_no && formik.errors.mobile_no ? (
                          <div className="text-danger">
                            {formik.errors.mobile_no}
                          </div>
                        ) : null}
                      </div>
                    </div> */}
                    {/* <div className="row align-items-center mb-lg-4 mb-md-4 mb-4">
                      <div className="col-lg-5 col-md-6">
                        <label htmlFor="mobile_relation" className="form-label">
                          Mobile Number Belongs to*
                        </label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <SelectDropDown
                          name="mobile_relation"
                          id=""
                          value={formik.values.mobile_relation}
                          changeFunction={(value) =>
                            formik?.setFieldValue("mobile_relation", value)
                          }
                          options={Object.keys(
                            userOnboardGetData?.data?.mobile_email_relations
                          ).map((key) => ({
                            value: key,
                            label:
                              userOnboardGetData?.data?.mobile_email_relations[
                                key
                              ],
                          }))}
                        />
                        {formik.touched.mobile_relation &&
                        formik.errors.mobile_relation ? (
                          <div className="text-danger">
                            {formik.errors.mobile_relation}
                          </div>
                        ) : null}
                      </div>
                    </div> */}
                    <div className="row align-items-center mb-lg-4 mb-md-4 mb-4">
                      <div className="col-lg-5 col-md-6">
                        <label className="form-label">Gender*</label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          {genderOptions.map(({ value, label }) => (
                            <div
                              className="form-check form-check-inline"
                              key={value}
                            >
                              <input
                                className="form-check-input"
                                type="radio"
                                name="gender"
                                id={value}
                                value={value}
                                onChange={formik.handleChange}
                                checked={formik.values.gender === value}
                              />
                              <label
                                className="form-check-label ms-2"
                                htmlFor={value}
                              >
                                {label}
                              </label>
                            </div>
                          ))}
                        </div>
                        {formik.touched.gender && formik.errors.gender ? (
                          <div className="text-danger">
                            {formik.errors.gender}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {/* <div className="row align-items-center mb-lg-4 mb-md-4 mb-4">
                      <div className="col-lg-5 col-md-6">
                        <label className="form-label">Holding Nature*</label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          {maritalOptions.map(({ value, label }) => (
                            <div
                              className="form-check form-check-inline"
                              key={value}
                            >
                              <input
                                className="form-check-input"
                                type="radio"
                                name="holding_nature"
                                id={value}
                                value={value}
                                onChange={formik.handleChange}
                                checked={formik.values.holding_nature === value}
                              />
                              <label
                                className="form-check-label ms-2"
                                htmlFor={value}
                              >
                                {label}
                              </label>
                            </div>
                          ))}
                        </div>

                        {formik.touched.holding_nature &&
                        formik.errors.holding_nature ? (
                          <div className="text-danger">
                            {formik.errors.holding_nature}
                          </div>
                        ) : null}
                      </div>
                    </div> */}
                    
                    {(formik.values.holding_nature === "JO" ||
                      formik.values.holding_nature === "AS") && (
                      <>
                        {/* <div>
                          <label>Second Holder First Name</label>
                          <input
                            type="text"
                            name="second_holder_first_name"
                            value={formik.values.second_holder_first_name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.second_holder_first_name &&
                            formik.errors.second_holder_first_name && (
                              <div className="text-danger">
                                {formik.errors.second_holder_first_name}
                              </div>
                            )}
                        </div> */}
                        {/* <div className="row align-items-center mb-lg-4 mb-md-4 mb-4">
                          <div className="col-lg-5 col-md-6">
                            <label htmlFor="email" className="form-label">
                              Second Holder First Name
                            </label>
                          </div>
                          <div className="col-lg-7 col-md-6">
                            <input
                              type="second_holder_first_name"
                              className="form-control"
                              id="second_holder_first_name"
                              placeholder="xyz"
                              {...formik.getFieldProps(
                                "second_holder_first_name"
                              )}
                            />
                            {formik.touched.second_holder_first_name &&
                            formik.errors.second_holder_first_name ? (
                              <div className="text-danger">
                                {formik.errors.second_holder_first_name}
                              </div>
                            ) : null}
                          </div>
                        </div> */}
                        <div className="row align-items-center mb-lg-4 mb-md-4 mb-4">
                          <div className="col-lg-5 col-md-6">
                            <label htmlFor="email" className="form-label">
                              Second Holder Middle Name
                            </label>
                          </div>
                          <div className="col-lg-7 col-md-6">
                            <input
                              type="second_holder_middle_name"
                              className="form-control"
                              id="second_holder_middle_name"
                              placeholder="xyz"
                              {...formik.getFieldProps(
                                "second_holder_middle_name"
                              )}
                            />
                            {formik.touched.second_holder_middle_name &&
                            formik.errors.second_holder_middle_name ? (
                              <div className="text-danger">
                                {formik.errors.second_holder_middle_name}
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="row align-items-center mb-lg-4 mb-md-4 mb-4">
                          <div className="col-lg-5 col-md-6">
                            <label htmlFor="email" className="form-label">
                              Second Holder Last Name
                            </label>
                          </div>
                          <div className="col-lg-7 col-md-6">
                            <input
                              type="second_holder_last_name"
                              className="form-control"
                              id="second_holder_last_name"
                              placeholder="xyz"
                              {...formik.getFieldProps(
                                "second_holder_last_name"
                              )}
                            />
                            {formik.touched.second_holder_last_name &&
                            formik.errors.second_holder_last_name ? (
                              <div className="text-danger">
                                {formik.errors.second_holder_last_name}
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="row align-items-center mb-lg-4 mb-md-4 mb-4">
                          <div className="col-lg-5 col-md-6">
                            <label htmlFor="email" className="form-label">
                              Second Holder Pan Number
                            </label>
                          </div>
                          <div className="col-lg-7 col-md-6">
                            <input
                              type="second_holder_pan"
                              className="form-control"
                              id="second_holder_pan"
                              placeholder="Enter PAN"
                              {...formik.getFieldProps("second_holder_pan")}
                            />
                            {formik.touched.second_holder_pan &&
                            formik.errors.second_holder_pan ? (
                              <div className="text-danger">
                                {formik.errors.second_holder_pan}
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="row align-items-center mb-lg-4 mb-md-4 mb-4">
                          <div className="col-lg-5 col-md-6">
                            <label htmlFor="email" className="form-label">
                              Second Holder Email
                            </label>
                          </div>
                          <div className="col-lg-7 col-md-6">
                            <input
                              type="second_holder_email"
                              className="form-control"
                              id="second_holder_email"
                              placeholder="Enter Email"
                              {...formik.getFieldProps("second_holder_email")}
                            />
                            {formik.touched.second_holder_email &&
                            formik.errors.second_holder_email ? (
                              <div className="text-danger">
                                {formik.errors.second_holder_email}
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="row align-items-center mb-lg-4 mb-md-4 mb-4">
                          <div className="col-lg-5 col-md-6">
                            <label htmlFor="email" className="form-label">
                              Second Holder Mobile
                            </label>
                          </div>
                          <div className="col-lg-7 col-md-6">
                            <input
                              type="second_holder_mobile"
                              className="form-control"
                              id="second_holder_mobile"
                              placeholder="Enter Mobile"
                              {...formik.getFieldProps("second_holder_mobile")}
                            />
                            {formik.touched.second_holder_mobile &&
                            formik.errors.second_holder_mobile ? (
                              <div className="text-danger">
                                {formik.errors.second_holder_mobile}
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="row align-items-center mb-4">
                          <div className="col-lg-5 col-md-6">
                            <label
                              htmlFor="primary_holder_dob_incorporation"
                              className="form-label"
                            >
                              Second Holder Date of Birth*
                            </label>
                          </div>
                          <div className="col-lg-7 col-md-6">
                            <DatePickerInput
                              selectedDate={
                                formik.values.second_holder_dob
                                  ? moment(
                                      formik.values.second_holder_dob,
                                      "YYYY-MM-DD"
                                    ).toDate()
                                  : null
                              }
                              maxDate={new Date().toISOString().split("T")[0]}
                              onChange={(date) =>
                                formik.setFieldValue(
                                  "second_holder_dob",
                                  moment(date).format("YYYY-MM-DD") // Save in DB-friendly format
                                )
                              }
                            />
                            {/* <DatePickerInput
                          selectedDate={
                            formik.values.primary_holder_dob_incorporation
                          }
                          maxDate={new Date().toISOString().split("T")[0]}
                          onChange={(date) =>
                            formik.setFieldValue(
                              "primary_holder_dob_incorporation",
                              date
                            )
                          }
                        /> */}
                            {formik.touched.second_holder_dob &&
                            formik.errors.second_holder_dob ? (
                              <div className="text-danger">
                                {formik.errors.second_holder_dob}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </>
                    )}

                    {/* <div className="row align-items-center mb-lg-4 mb-md-4 mb-4">
                      <div className="col-lg-5 col-md-6">
                        <label htmlFor="father_name" className="form-label">
                          Father/Husband Name*
                        </label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          id="father_name"
                          placeholder="Enter Father/Husband Name"
                          {...formik.getFieldProps("father_name")}
                        />
                        {formik.touched.father_name &&
                        formik.errors.father_name ? (
                          <div className="text-danger">
                            {formik.errors.father_name}
                          </div>
                        ) : null}
                      </div>
                    </div> */}
                    <div className="row align-items-center mb-lg-4 mb-md-4 mb-3">
                      <div className="col-lg-5 col-md-6">
                        <label htmlFor="occupation_code" className="form-label">
                          Occupation*
                        </label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <SelectDropDown
                          name="occupation_code"
                          id=""
                          value={formik?.values?.occupation_code}
                          changeFunction={(value) =>
                            formik?.setFieldValue("occupation_code", value)
                          }
                          options={userOnboardGetData?.data?.occupations?.map(
                            (occ) => ({
                              value: occ.occupation_code,
                              label: occ.occupation_name,
                            })
                          )}
                        />
                        {formik.touched.occupation_code &&
                        formik.errors.occupation_code ? (
                          <div className="text-danger">
                            {formik.errors.occupation_code}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="row align-items-center mb-lg-4 mb-md-4 mb-4">
                      <div className="col-lg-5 col-md-6">
                        <label
                          htmlFor="primary_holder_pan"
                          className="form-label"
                        >
                          PAN*
                        </label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          id="primary_holder_pan"
                          placeholder="Enter PAN"
                          {...formik.getFieldProps("primary_holder_pan")}
                          disabled
                        />
                        {formik.touched.primary_holder_pan &&
                        formik.errors.primary_holder_pan ? (
                          <div className="text-danger">
                            {formik.errors.primary_holder_pan}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {/* <div className="row align-items-center mb-lg-4 mb-md-4 mb-4">
                      <div className="col-lg-5 col-md-6">
                        <label htmlFor="addr1" className="form-label">
                          Aadhar Number*
                        </label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          id="adhaar_card"
                          placeholder="Enter Aadhar Number"
                          {...formik.getFieldProps("adhaar_card")}
                        />
                        {formik.touched.adhaar_card &&
                        formik.errors.adhaar_card ? (
                          <div className="text-danger">
                            {formik.errors.adhaar_card}
                          </div>
                        ) : null}
                      </div>
                    </div> */}
                    <div className="row align-items-center mb-lg-4 mb-md-4 mb-4">
                      <div className="col-lg-5 col-md-6">
                        <label htmlFor="address_1" className="form-label">
                          Address*
                        </label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          id="address_1"
                          placeholder="Enter Address"
                          {...formik.getFieldProps("address_1")}
                        />
                        {formik.touched.address_1 && formik.errors.address_1 ? (
                          <div className="text-danger">
                            {formik.errors.address_1}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="row align-items-center mb-lg-4 mb-md-4 mb-4">
                      <div className="col-lg-5 col-md-6">
                        <label htmlFor="pincode" className="form-label">
                          Pincode*
                        </label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          id="pincode"
                          name="pincode"
                          placeholder="Enter Pincode"
                          onChange={(e) => {
                            formik.handleChange(e); // Handle Formik's change
                            callStateAndDistrict(e.target.value); // Call your custom function
                          }}
                          value={formik.values.pincode}
                        />
                        {formik.touched.pincode && formik.errors.pincode ? (
                          <div className="text-danger">
                            {formik.errors.pincode}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="row align-items-center mb-lg-4 mb-md-4 mb-4">
                      <div className="col-lg-5 col-md-6">
                        <label htmlFor="city" className="form-label">
                          City*
                        </label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          id="city"
                          placeholder="Enter City"
                          {...formik.getFieldProps("city")}
                        />
                        {formik.touched.city && formik.errors.city ? (
                          <div className="text-danger">
                            {formik.errors.city}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <div className="col-lg-5 col-md-6">
                        <label htmlFor="state" className="form-label">
                          State*
                        </label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <SelectDropDown
                          name="state"
                          id=""
                          value={formik?.values?.state}
                          changeFunction={(value) =>
                            formik?.setFieldValue("state", value)
                          }
                          options={userOnboardGetData?.data?.states?.map(
                            (state) => ({
                              value: state.state_code,
                              label: state.state_name,
                            })
                          )}
                        />
                        {formik.touched.state && formik.errors.state ? (
                          <div className="text-danger">
                            {formik.errors.state}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-5 col-lg-4 ps-xl-5 order-lg-2 order-1 mb-lg-0 mb-4">
                    <div className="info-box px-lg-4">
                      <div className="d-flex align-items-start">
                        <img
                          src={help_icon}
                          alt=""
                          className="me-3"
                          style={{ width: "24px", height: "24px" }}
                        />
                        <div>
                          <h5 className="fw-semibold mb-3">
                            Help Us Know You Better
                          </h5>
                          <p className="mb-2">
                            Provide basic details to create your profile.
                            Accurate information allows us to tailor your
                            experience and help you achieve your financial
                            goals.
                          </p>
                          <p className="highlight_text">
                            You can edit these details later if needed.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer form_card card_footer">
                <div className="">
                  <div className="d-flex justify-content-end gap-2">
                    <button
                      type="submit"
                      className="form_button next_btn"
                      //   onClick={handleNextClick}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PersonalDetails;
